import { atom } from "recoil";

export const actionProfitRows = atom({
  key: "actionProfitRows",
  default: null,
});
